import { useEffect, useState } from 'react';
import classNames from 'classnames';
import CountUp from 'react-countup';
import WidgetLink from '../WidgetLink/WidgetLink';

function WidgetProgressRow({
  label,
  count,
  total,
  colorClass,
  labelClassName = 'text-sm text-gray-300',
  linkClassName = 'text-sm',
  labelWidthClass = 'w-32',
  showDot = true,
  animationDelay = 0,
  to,
}) {
  const [isReady, setIsReady] = useState(false);
  const pct = total > 0 ? (count / total) * 100 : 0;

  useEffect(() => {
    const frameId = window.requestAnimationFrame(() => {
      setIsReady(true);
    });

    return () => window.cancelAnimationFrame(frameId);
  }, []);

  return (
    <div className="flex items-center gap-3">
      <div className={classNames('flex shrink-0 items-center gap-3', labelWidthClass)}>
        {showDot && <div className={classNames('h-2.5 w-2.5 rounded-full shrink-0', colorClass)} />}
        {to ? (
          <WidgetLink to={to} className={linkClassName}>
            {label}
          </WidgetLink>
        ) : (
          <span className={classNames('min-w-0', labelClassName)}>{label}</span>
        )}
      </div>
      <div className="flex-1 h-2 rounded-full bg-gray-800 overflow-hidden">
        <div
          className={classNames('h-full rounded-full transition-all duration-700 ease-out', colorClass)}
          style={{
            width: isReady ? `${pct}%` : '0%',
            transitionDelay: `${animationDelay}ms`,
          }}
        />
      </div>
      <span className="w-8 text-right text-sm font-medium text-white tabular-nums">
        <CountUp
          end={count}
          duration={0.9}
          delay={animationDelay / 1000}
          preserveValue
        />
      </span>
    </div>
  );
}

export default WidgetProgressRow;
